/**
 * @generated SignedSource<<dc7910fd081b78e171ae3d0e0ab85775>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InspectionfieldStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "OPEN" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
export type ScanInspectionInspectionFieldReasonChoices = "A_0" | "A_1" | "A_2" | "A_3" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InspectionDetailsContainer$data = {
  readonly assignedDate: any | null;
  readonly field: {
    readonly id: string;
    readonly member: {
      readonly company: {
        readonly address: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly city: string | null;
              readonly houseNumber: number | null;
              readonly id: string;
              readonly street: string | null;
              readonly zipcode: string | null;
            } | null;
          } | null>;
        };
      } | null;
      readonly email: string | null;
      readonly name: string;
      readonly phone: string | null;
    } | null;
    readonly previousId: number | null;
    readonly year: number;
  } | null;
  readonly latestInspection: {
    readonly approvedDate: any | null;
    readonly lastModified: any | null;
    readonly rejectedDate: any | null;
    readonly retryDate: any | null;
  } | null;
  readonly managementPackageSetting: {
    readonly displayNameAlt: string | null;
    readonly pdfFileUrl: string | null;
  } | null;
  readonly member: {
    readonly company: {
      readonly address: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly city: string | null;
            readonly houseNumber: number | null;
            readonly id: string;
            readonly street: string | null;
            readonly zipcode: string | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly email: string | null;
    readonly name: string;
    readonly phone: string | null;
  } | null;
  readonly name: string;
  readonly notes: string;
  readonly periodEnd: any | null;
  readonly periodStart: any | null;
  readonly plannedDate: any | null;
  readonly reason: ScanInspectionInspectionFieldReasonChoices | null;
  readonly state: InspectionfieldStateEnum | null;
  readonly year: number;
  readonly " $fragmentType": "InspectionDetailsContainer";
};
export type InspectionDetailsContainer$key = {
  readonly " $data"?: InspectionDetailsContainer$data;
  readonly " $fragmentSpreads": FragmentRefs<"InspectionDetailsContainer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberNode",
  "kind": "LinkedField",
  "name": "member",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNode",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AddressNodeConnection",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AddressNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AddressNode",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "street",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "houseNumber",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "zipcode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "city",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InspectionDetailsContainer",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "periodStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "periodEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assignedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionNode",
      "kind": "LinkedField",
      "name": "latestInspection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "approvedDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rejectedDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastModified",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "retryDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ManagementPackageSettingsNode",
      "kind": "LinkedField",
      "name": "managementPackageSetting",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pdfFileUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayNameAlt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FieldNode",
      "kind": "LinkedField",
      "name": "field",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "previousId",
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "InspectionfieldNode",
  "abstractKey": null
};
})();

(node as any).hash = "d6b5e5d090d8832bfa634c5a8e09b11a";

export default node;
